export const programingSkills = [
    {type: "C", level: 45,},
    {type: "Java", level: 59,},
    {type: "PHP", level: 65,},
    {type: "TypeScript", level: 56,},
    {type: "JavaScript", level: 56,},
    {type: "Dart", level: 40,},
    {type: "Nodejs", level: 71,},
    {type: "Docker", level: 36,},
    {type: "SQL", level: 45,},
    {type: "NoSQL", level: 30,},
    {type: "HTML/Css", level: 70,}
];



export const frameworkSkills = [
    {type: "Angular", level: 45},
    {type: "React", level: 40},
    {type: "VueJs", level: 35,},
    {type: "flutter", level: 49},
    {type: "Spring",level: 35},
    {type: "Springboot", level: 55}
];